import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import Popup from 'popup/Popup';
import MainPopup from '../MainPopup';
import { IconContainer } from './StatusComponentIcon.css.js';
import usePrevious from 'utils/customHook/usePrevious';
import useCancellationToken from 'utils/customHook/useCancellationToken';
import { getYMDAndTimeFormatDate } from 'utils/getCustomFormatDate';
import { nvl } from 'utils/nvl';
import { batteryToImg } from 'utils/utils';
import { moduleScnMap, titleInitial } from 'utils/code';

const StatusIcon = (props) => {

  const cancellationToken = useCancellationToken();
  const dispatch = useDispatch();
  const [warningTime, setWarningTime] = useState(null);
  const prevAmount = usePrevious(props.status, cancellationToken.isCancelled);

  useEffect(() => {
    if (cancellationToken.isCancelled) {
      return;
    }

    if (props.status !== 'blue' && props.status !== prevAmount) {
      setWarningTime(getYMDAndTimeFormatDate(new Date(props.rgstDt)));
    } else if (props.status === 'blue' && props.status !== prevAmount) {
      setWarningTime(null);
    }
  }, [props.status]);

  // 위험알람 hooks 로직
  useEffect(() => {
    if (nvl(prevAmount, null) !== null && props.status !== 'blue' && prevAmount !== props.status) {
      if (props.status !== 'none') {
        dispatch({ type: 'ALERT_INSERT', data: { ...props, userPhone: '' } });
      }
    }
  }, [props.status, cancellationToken]);

  useEffect(() => () => cancellationToken.cancel(), []);

  return (
    <Popup
      trigger={
        <IconContainer statusFlag={props.status} count={props.count}>
          <div className="statusImage">
            <div className="titleInitial">{titleInitial[props.title]}</div>
            <div className={props.status}>
              <p>{props.modelNm}</p>
            </div>
            {batteryToImg(props.battery)}
            <img src="" alt="mainInfo_Icon_blue" />
          </div>
        </IconContainer>
      }
      modal
      closeOnDocumentClick
    >
      <div style={{ background: `#272F3C`, borderRadius: `10px`, padding: `10px` }}>
        <div style={{ display: `flex`, justifyContent: `center`, alignItems: `center`, fontSize: `35px` }}>
          {moduleScnMap[props.moduleScn].viewTitle} / &nbsp;
          {props.modelNm}
        </div>
        <MainPopup {...props} />
      </div>
    </Popup>
  );
};

export default StatusIcon;
